import styled from 'styled-components';
import { BLACK, GRAYSCALE_500, NEUTRAL_100, WHITE } from "@styles/colors";
import { GIVONIC, INTER } from "@styles/fonts";
import HeaderBackground from '@assets/images/HomeBackground.png';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const BackgroundImage = styled.div<{ $scrollY: number; $headerOpacity?: number }>`
  background-image: url(${HeaderBackground});
  background-size: contain;
  background-position: 0% -30%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  opacity: ${props => Math.max(0, 1 - props.$scrollY * 0.003)};
  transition: opacity 0.05s ease-out;
`;

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  position: relative;
  z-index: 1;
  -ms-overflow-style: none;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  
  &.hide-scrollbar::-webkit-scrollbar {
    display: none;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  gap: 8px;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TransactionContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${WHITE};
`;

export const StickyHeader = styled.div<{ $headerTop?: number; $headerOpacity?: number }>`
  position: sticky;
  top: ${props => props.$headerTop !== undefined ? props.$headerTop : 0}px;
  left: 0;
  width: 100%;
  z-index: 10;
  opacity: ${props => props.$headerOpacity !== undefined ? props.$headerOpacity : 1};
  transition: top 0.2s ease-out, opacity 0.2s ease-out;
  background-color: ${WHITE};
  padding-top: 8px;
  padding-bottom: 8px;
`;

export const SectionTitleText = styled.span`
  font-family: ${GIVONIC.regular};
  font-size: 14px;
  color: ${BLACK};
  text-transform: uppercase;
`;

export const QuotationButton = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
  padding: 16px 12px;
  background-color: ${WHITE};
`;

export const QuotationIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const QuotationTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  color: ${BLACK};
  font-family: ${INTER.regular};
`;

export const QuotationTitle = styled.span`
  font-family: ${INTER.medium};
`;

export const QuotationSubtitle = styled.p`
    font-size: 12px;
    color: ${GRAYSCALE_500};
    margin: 0;
    font-weight: 400;
`

export const ButtonWrapper = styled.div`
    position: relative;
`

export const ButtonOverlay = styled.div`
    height: 100%;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.4);
    position: absolute;
    border-radius: 12px;
    left: 0;
    top: 0;
`

export const ModalContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
`
